import { render, staticRenderFns } from "./YoutubeFrame.vue?vue&type=template&id=4a04f8c0&scoped=true&"
import script from "./YoutubeFrame.vue?vue&type=script&lang=js&"
export * from "./YoutubeFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a04f8c0",
  null
  
)

export default component.exports